import { ValidationResult, validateSingleField, validateForm } from '@/utils/validation';

import { UploadDocumentFormData } from './types';
import { validationRules } from './validation';

/**
 * Determine if a field should be validated based on its context.
 * For upload document forms, files are always required.
 */
const isFieldRequired = (
  field: keyof UploadDocumentFormData,
  _data: UploadDocumentFormData,
): boolean => {
  const rule = validationRules[field];
  return rule.required === true;
};

/**
 * Validate all fields in the upload document form
 */
export const validateUploadDocumentForm = (
  data: UploadDocumentFormData,
): ValidationResult<UploadDocumentFormData> => {
  return validateForm(data, validationRules, isFieldRequired);
};

/**
 * Validate a single field and return its error
 */
export const validateSingleFieldUploadDocument = (
  field: keyof UploadDocumentFormData,
  value: unknown,
  data: UploadDocumentFormData,
): string | undefined => {
  return validateSingleField(field, value, data, validationRules, isFieldRequired);
};

// Export validation rules for potential external use
export { validationRules };
